import React from 'react'
import Portal from 'react-portal'

const Overlay = ({
	openByClickOn,
	children,
	closePortal,
	handleClose,
	isOpened
}) => (
	<Portal
		closeOnEsc
		openByClickOn={openByClickOn}
		onClose={handleClose}
		isOpened={isOpened || false}
	>
		{React.cloneElement(children, {
			closePortal
		})}
	</Portal>
)

export default Overlay



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Overlay/Overlay.js